import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

@Injectable()
export class FeedbackService {
  private apiPrefix = '/admin/feedbacks';

  constructor(
    private api: ApiService,
  ) {
  }

  getFeedbacks(qs = '') {
    return this.api.get(`${this.apiPrefix}${qs}`);
  }

  deleteFeedback(id: number) {
    return this.api.delete(`${this.apiPrefix}/${id}`);
  }

  markViewed(id: number) {
    return this.api.patch(`${this.apiPrefix}/${id}/viewed`, {});
  }

  markUnviewed(id: number) {
    return this.api.patch(`${this.apiPrefix}/${id}/unviewed`, {});
  }
}
